import styled from 'styled-components';

import { Pane as CommonPane, Detail as CommonDetail } from 'components/common';
import { colours } from 'utils/theme';

export const Container = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  margin-top: ${p => p.theme.gutter};
  gap: ${p => p.theme.gutter};
`;

export const Pane = styled(CommonPane)`
  flex: 1;
  margin-right: ${p => p.theme.gutter};
  margin-bottom: ${p => p.theme.gutter};
  :last-child {
    margin-right: 0px;
  }
  ${p => p.theme.breakpoint.mobile} {
    margin-bottom: ${p => p.theme.gutter};
    :last-child {
      margin-bottom: 0px;
    }
  }
  .content {
    margin-top: 5px;
  }
`;

export const Title = styled.div`
  font-weight: bold;
  font-size: 18px;
`;

export const LeftPanes = styled.div`
  display: flex;
  flex: 2;
  flex-direction: column;
`;

export const RightPanes = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  align-items: flex-start;
`;

export const Detail = styled(CommonDetail)`
  margin-bottom: 10px;
  min-width: 100px;
  line-height: 1.4em;
  font-size: 14px;
`;

export const DetailWithIcon = styled.div`
  display: inline-flex;
  gap: 5px;
  align-items: baseline;
  font-size: 14px;
  line-height: 1.4em;
  margin-bottom: 5px;
`;

export const VirtualLocationPip = styled.div`
  display: flex;
  align-items: center;
  gap: 5px;
  border-radius: 20px;
  background-color: ${colours.lightGrey};
  padding: 2px 10px;
  font-size: 14px;
  width: fit-content;
  height: fit-content;
  margin-top: 15px;
`;

export const Row = styled.div`
  display: flex;
  align-items: flex-start;
`;

export const InlineFlexGroup = styled.div`
  display: inline-flex;
  gap: 20px;
`;
